import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

// Billing routes go through the DA API Gateway at /:id_company/billing/...
// Verified in digital-admin-api-gateway-for-web/src/routes.ts:130
export class BillingDA {
  static apiResponse: ApiResponse

  public static async getInvoices(
    id_company: string,
    page: number = 1,
    limit: number = 20
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/billing/invoices?page=${page}&limit=${limit}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: null
      }
    })

    return this.apiResponse
  }

  public static async getInvoice(
    id_company: string,
    invoice_id: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/billing/invoices/${invoice_id}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: null
      }
    })

    return this.apiResponse
  }

  public static async createPaymentLink(
    id_company: string,
    invoice_id: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/billing/invoices/${invoice_id}/payment-link`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, {}, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }

  public static async getPayments(
    id_company: string,
    page: number = 1,
    limit: number = 20
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/billing/payments?page=${page}&limit=${limit}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: null
      }
    })

    return this.apiResponse
  }

  public static async getPaymentMethods(
    id_company: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/billing/payment-methods`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: null
      }
    })

    return this.apiResponse
  }

  public static async setupPaymentMethod(
    id_company: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/billing/payment-methods/setup`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, {}, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }

  public static async deletePaymentMethod(
    id_company: string,
    method_id: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/billing/payment-methods/${method_id}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.delete(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.success === true ? response.data.data : (response.data ?? null)
      }
    }).catch(error => {
      this.apiResponse = {
        status: error?.response?.status ?? 500,
        message: error?.response?.statusText ?? 'Error',
        data: error?.response?.data?.error ?? null
      }
    })

    return this.apiResponse
  }
}
